type OpenAIAdsData =
  | {
      type: 'contents';
      contents?: Array<{
        id?: string;
        name?: string;
        content_type?: string;
        quantity?: number;
        amount?: number;
        currency?: string;
      }>;
    }
  | {
      type: 'customer_action';
      amount?: number;
      currency?: string;
    }
  | {
      type: 'custom';
      plan_id?: string;
      amount?: number;
      currency?: string;
      contents?: Array<{
        id?: string;
        name?: string;
        content_type?: string;
        quantity?: number;
        amount?: number;
        currency?: string;
      }>;
    };

type OpenAIAdsOptions = {
  event_id?: string;
  custom_event_name?: string;
  opt_out?: boolean;
};

declare global {
  interface Window {
    oaiq?: (
      command: 'measure',
      eventName: string,
      data: OpenAIAdsData,
      options?: OpenAIAdsOptions
    ) => void;
  }
}

const appStoreUrl =
  'https://apps.apple.com/us/app/uncling-no-contact-tracker/id6751050476?ppid=7680204b-0df8-494b-898d-13c131f6ce97';
const googlePlayUrl = 'https://play.google.com/store/apps/details?id=com.uncling';

const measureOpenAIAds = (eventName: string, data: OpenAIAdsData, options?: OpenAIAdsOptions) => {
  try {
    window.oaiq?.('measure', eventName, data, options);
  } catch {
    // Measurement must never block navigation or app downloads.
  }
};

export const trackOpenAIAdsPageView = (path: string) => {
  if (path === '/') {
    measureOpenAIAds('page_viewed', { type: 'contents' });
    return;
  }

  measureOpenAIAds('page_viewed', {
    type: 'contents',
    contents: [
      {
        id: path || '/',
        name: document.title || 'Uncling page',
        content_type: 'page'
      }
    ]
  });
};

export const trackOpenAIAdsAppDownloadClick = (destination: 'app_store' | 'google_play', source: string) => {
  measureOpenAIAds(
    'custom',
    {
      type: 'custom',
      contents: [
        {
          id: destination,
          name: `${destination === 'app_store' ? 'App Store' : 'Google Play'} download click`,
          content_type: 'app_download'
        }
      ]
    },
    {
      custom_event_name: 'app_download_clicked',
      event_id: `${destination}-${source}-${Date.now()}`
    }
  );
};

export const openAppStoreWithOpenAIAds = (source: string) => {
  trackOpenAIAdsAppDownloadClick('app_store', source);
  window.open(appStoreUrl, '_blank');
};

export { appStoreUrl, googlePlayUrl };
